import { useContext } from 'react';

// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';

type SupporterTierId = 'low' | 'mid' | 'high' | 'custom';

type Props = {
  checked?: boolean;
  children?: React.ReactNode;
  id: SupporterTierId;
  onClick?: () => void;
};

const SupporterTier = (props: Props) => {
  const [state, dispatch] = useContext(Context);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | undefined>) => {
    dispatch({
      type: ActionTypes.supporterChangeTier,
      payload: {
        key: 'supporter.selection.tier',
        value: event.target.value
      }
    });
  };

  return (
    <li onClick={props.onClick}>
      <input
        checked={Boolean(props.checked)}
        id={props.id}
        name="supporter-tier"
        onChange={handleChange}
        type="radio"
        value={props.id !== 'custom' ? state.supporter.tiers[props.id] : ''}
      />

      <label htmlFor={props.id}>{props.id !== 'custom' ? `${parseInt(state.supporter.tiers[props.id], 10)}€` : 'anderer Betrag'}</label>

      {props.children}
    </li>
  );
};

export { SupporterTier };
